import { NotificationManager } from 'react-notifications';
import axios, { AxiosError } from 'axios';
import {
  IGetPaymentCommission,
  IPaymentCommission,
  IPaymentCommissionCreate,
  IPaymentCommissionToggle,
  TPaymentCommissionResponse,
} from 'src/store/api/paymentCommission/types';

const getPaymentCommissions = async (props: IGetPaymentCommission): Promise<TPaymentCommissionResponse | undefined> => {
  const { data, params } = props;
  try {
    const res = await axios.post(`/api/v1/payment/commissions/filter`, data, { params });
    return res.data;
  } catch (e) {
    NotificationManager.error('Fetch commissions error');
  }
};

const getPaymentCommission = async (commissionId: number): Promise<IPaymentCommission | undefined> => {
  try {
    const res = await axios.get(`/api/v1/payment/commissions/${commissionId}`);
    return res.data;
  } catch (e) {
    NotificationManager.error('Fetch commission error');
  }
};

const createPaymentCommission = async (data: IPaymentCommissionCreate): Promise<IPaymentCommission | undefined> => {
  try {
    const res = await axios.post(`/api/v1/payment/commissions`, data);
    return res.data;
  } catch (err) {
    const errors = err as AxiosError<{ message: string }>;
    if (axios.isAxiosError(errors) && errors.response) {
      NotificationManager.error(errors.response?.data.message);
    }
  }
};

const updatePaymentCommission = async (commissionId: number, data: IPaymentCommissionCreate): Promise<IPaymentCommission | undefined> => {
  try {
    const res = await axios.put(`/api/v1/payment/commissions/${commissionId}`, data);
    return res.data;
  } catch (err) {
    const errors = err as AxiosError<{ message: string }>;
    if (axios.isAxiosError(errors) && errors.response) {
      NotificationManager.error(errors.response?.data.message);
    }
  }
};

const togglePaymentCommission = async (commissionId: number, data: IPaymentCommissionToggle): Promise<IPaymentCommission | undefined> => {
  try {
    const res = await axios.patch(`/api/v1/payment/commissions/${commissionId}/active/toggle`, data);
    return res.data;
  } catch (e) {
    NotificationManager.error('Toggle change commission error');
  }
};

export const paymentCommissionApi = {
  getPaymentCommissions,
  togglePaymentCommission,
  createPaymentCommission,
  updatePaymentCommission,
  getPaymentCommission,
};
